import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import CreateWorkshop from '../Components/casp/agenda/CreateWorkshop';
import dayjs from 'dayjs';
import { Container } from 'reactstrap';
import BreadCrumb from '../Components/Common/BreadCrumb';
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { Helmet } from 'react-helmet';
import { InsertChartOutlinedOutlined } from '@mui/icons-material';
import { getIconPath } from '../helpers/file_helper';
import { withTranslation,useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { createdWorkshop, deleteWorkshop, getWorkshopList, updateWorkshop } from '../api/casp/workshop';
import { Action, Role } from '../constants/Common';
import { useSelector } from 'react-redux';
import allLocales from '@fullcalendar/core/locales-all';

const WorkshopList = ({ t }) => {
  const [events, setEvents] = useState([]);
  const [workshopList, setWorkshopList] = useState([])
  const [isAddEventModal, setIsAddEventModal] = useState({
    status: false,
    data: '',
    action: ''
  })
  const loggedInUser = useSelector((state) => state.Profile.user);

  const {i18n} = useTranslation();
  const [currentLocale, setCurrentLocale] = useState(i18n.language);
  useEffect(() => {
    setCurrentLocale(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    getAllEvents()
  }, [])

  const getAllEvents = async () => {
    try {
      const res = (
        await getWorkshopList()
      ).data.data;
      const result = res?.map((item) => {
        return {
          id: item?.id,
          title: item?.name,
          start: `${dayjs(item?.date).format('YYYY-MM-DD')}T${item?.startTime}`,
          end: `${dayjs(item?.date).format('YYYY-MM-DD')}T${item.endTime}`,
          allDay: false,
          portfolio: item?.portfolio
        }
      })
      setEvents(result)
      setWorkshopList(res)
    } catch (err) {
      console.log(err)
    }
  }

  const handleDateClick = (arg) => {
    if (dayjs(arg.date).isBefore(dayjs(), 'date') || loggedInUser?.role?.name !== Role.EPMO_OFFICER) {
      return
    }
    setIsAddEventModal({
      status: true,
      data: {
        date: dayjs(arg.date)
      },
      action: Action.CREATE
    });
  };

  const handleEventClickForUpdateAndRemove = (clickInfo) => {
    const eventId = clickInfo.event.id;
    const selectData = workshopList?.find((item) => item?.id === parseInt(eventId))
    setIsAddEventModal({
      status: true,
      data: selectData,
      action: dayjs(selectData.date).isBefore(dayjs(), 'date') ? Action.VIEW : Action.EDIT
    })
  };

  const handleCreate = async (data) => {
    try {
      const payload = {
        name: data.name,
        date: data.date.format("YYYY-MM-DD"),
        location: data.location,
        startTime: data.startTime,
        endTime: data.endTime,
        type: data?.type,
        isAttendance: data?.isAttendance,
        portfolioId: data?.portfolio?.id,
        ...(data?.details && {
          details: data?.details
        })
      };
      let response
      if (isAddEventModal?.action === Action.CREATE) {
        response = await createdWorkshop(payload);
      } else {
        response = await updateWorkshop(isAddEventModal?.data?.id, payload);
      }
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        getAllEvents()
        setIsAddEventModal({
          status: false,
          data: ""
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handelDelete = async () => {
    try {
      const response = await deleteWorkshop(isAddEventModal?.data?.id);
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        getAllEvents()
        setIsAddEventModal({
          status: false,
          data: ""
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="page-content position-relative">
      <Helmet
        onChangeClientState={(newState) => {
          try {
            // Check if we added any new link[rel="icon"] elements.
            const newFaviconElems = filter(get(newState, "linkTags", []), {
              rel: "icon",
            });
            if (!newFaviconElems.length) {
              return;
            }
            // Get the href of the last link element we just added, which
            // we assume is the most recently-added favicon.
            const newFaviconHref =
              newFaviconElems[newFaviconElems.length - 1].href;
            // Remove all react-helmet link elements with rel="icon" that
            // do not have the href of our recently-added favicon.
            // If no other favicon elements exist, we don't have to do
            // anything.
            const existingFavicons = document.querySelectorAll(
              `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
            );
            if (existingFavicons.length) {
              existingFavicons.forEach((e) => e.parentNode.removeChild(e));
            }
            // Remove and re-add the latest link element to make sure
            // the browser uses it.
            const newFaviconElem = document.querySelector(
              `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
            );
            const iconToShow = <InsertChartOutlinedOutlined />;
            //<i className={'ri-git-pull-request-line'}></i>
            if (newFaviconElem) {
              const newFavElement = newFaviconElem.cloneNode(true);
              newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                  iconToShow
                )}</svg>`
              )}`;
              const parentElem = newFaviconElem.parentNode;
              parentElem.removeChild(newFaviconElem);
              parentElem.appendChild(newFavElement);
            }
          } catch (e) {
            console.error(e);
          }
        }}
      >
        <title>{t("Workshop")}</title>
      </Helmet>
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={t("Workshop View Calendar")} />
          </div>
        </div>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
          locales={allLocales}
          locale={currentLocale}
          initialView="dayGridMonth"
          nowIndicator={true}
          editable={true}
          selectable={true}
          eventClick={handleEventClickForUpdateAndRemove}
          headerToolbar={{
            start: 'today prev next',
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth"
          }}
          dateClick={handleDateClick}
          events={events}
          height={"90vh"}
          eventTimeFormat={{
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }}
          slotLabelFormat={{
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }}
        />
      </Container>

      {isAddEventModal?.status && (
        <CreateWorkshop
          open={isAddEventModal?.status}
          onClose={() => setIsAddEventModal({
            status: false,
            data: ''
          })}
          action={isAddEventModal?.action}
          selectedRow={isAddEventModal?.data}
          handleSubmit={(data) => isAddEventModal?.action === Action?.EDIT && !data?.type ? handelDelete() : handleCreate(data)}
        />
      )}
    </div>
  );
};

export default withTranslation()(WorkshopList);
